<template>
  <div class="form-builder module-observation">
    <div class="md-layout">
      <div v-if="submission && userRole !== 'learner_reviewer'">
        <h1>{{ observationLabel }}</h1>
      </div>
      <div class="md-layout-item md-align-text-right">
        <popper
          v-if="!isCompleted"
          ref="popper"
          trigger="clickToToggle"
          :options="{
            placement: 'bottom-end',
            modifiers: [{ offset: { offset: '0,0' } }],
          }"
        >
          <md-button
            @blur="menuOpen = false"
            @click="menuOpen = !menuOpen"
            slot="reference"
            ref="popperTrigger"
            >Delete {{ observationLabel }}</md-button
          >
          <div class="popper toolbar" ref="popperContent">
            <div class="popper-content md-card-content">
              <div class="md-layout">
                <div class="md-layout-item">
                  <p>Delete this {{ observationLabel }}?</p>
                </div>
              </div>
              <md-button class="md-primary" @click="deleteObservation"
                >Delete</md-button
              >
              <md-button class="md-button" @click="closeDeletePopper"
                >Cancel</md-button
              >
            </div>
          </div>
        </popper>
      </div>
    </div>
    <md-card v-if="!submission" class="observation-create">
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field class="fb-select">
              <label>{{ observationLabel }} Type:</label>
              <div class="text">{{ observationTitle }}</div>
              <span class="md-helper-text"></span>
            </md-field>

            <md-field class="fb-select">
              <label>{{ observationLabel }} for:</label>
              <md-select
                v-if="!isCompleted"
                placeholder="- Select -"
                id="select-view"
                v-model="learner"
                :multiple="false"
              >
                <md-option
                  v-bind:key="index"
                  v-for="(option, index) in learners"
                  :value="option.value"
                  >{{ option.label }}</md-option
                >
              </md-select>
              <div v-if="isCompleted" class="text">{{ learnerName }}</div>
              <span class="md-helper-text"></span>
            </md-field>

            <div class="date">
              <md-field class="fb-select">
                <label>{{ observationLabel }} Date:</label>
                <div v-if="isCompleted" class="text">
                  {{ observationDateText }}
                </div>
              </md-field>
              <datetime
                v-if="!isCompleted"
                v-model="observationDate"
                placeholder="Select date"
                type="date"
                format="MM/dd/yyyy"
                value-zone="local"
              ></datetime>
              <datetime
                v-if="!isCompleted"
                value-zone="local"
                v-model="observationTime"
                class="time"
                placeholder="Select time (optional)"
                type="time"
                format="h:mm a"
                use12-hour
              ></datetime>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-card v-if="submission" class="observation-header observation-create">
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-field class="fb-select">
              <label>{{ observationLabel }} Type:</label>
              <div class="text">{{ observationTitle }}</div>
              <span class="md-helper-text"></span>
            </md-field>

            <md-field class="fb-select">
              <label>By:</label>
              <div class="text">{{ coachName }}</div>
              <span class="md-helper-text"></span>
            </md-field>

            <div class="date">
              <md-field class="fb-select">
                <label>{{ observationLabel }} Date:</label>
                <div class="text">{{ observationDateText }}</div>
              </md-field>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-content>
      <md-card class="text-left observation-create" v-if="submission">
        <md-card-content>
          <activity-submission-element
            :sid="suuid"
            :key="item.uuid"
            v-for="item in submission"
            :elementData="item"
            :allowCommenting="true"
          ></activity-submission-element>
        </md-card-content>
      </md-card>
      <viewer-observation
        v-if="!submission"
        ref="viewer-observation"
        :nid="nuuid"
        :sid="suuid"
        :draft_sid="draft_suuid"
        field="activity_form"
        @set-sid="suuid = $event"
        @draft-send="draftSend"
        :elements="elements"
        :attributes="attributes"
      />
    </md-content>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import ViewerObservation from "./views/ViewerObservation";
import Activity from "./Activity";
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import Spinner from "./components/Spinner.vue";
import { Datetime } from "vue-datetime";

export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate"],
  mixins: [Activity],
  mounted() {
    this.initData(this.suuid, this.draft_suuid);
  },
  data() {
    let date = new Date(
      parseInt(window.drupalSettings.observation_date) * 1000
    );
    let time = new Date(
      parseInt(window.drupalSettings.observation_time) * 1000
    );
    let observationDateText = this.$moment(date).format("MM/DD/YYYY");
    if (
      window.drupalSettings.observation_time &&
      window.drupalSettings.observation_time !== null
    ) {
      observationDateText +=
        " " + this.$moment.utc(time).local().format("h:mm A");
    }
    return {
      submission: window.drupalSettings.submission_render_data,
      learner: window.drupalSettings.learner_uuid,
      observation: window.drupalSettings.observation_uuid,
      date: date,
      learners: window.drupalSettings.learners,
      observations: window.drupalSettings.observations,
      observationTitle: "",
      learnerName: "",
      coachName: window.drupalSettings.coach_name,
      observationDateText: observationDateText,
      menuOpen: false,
      showLoader: false,
      isCompleted: false,
      isStarted: false,
      observationDate: this.$moment(date).format(),
      observationTime: this.$moment(time).format(),
      observationLabel: window.drupalSettings.group_catch_config.labels.observation_label,
      userRole: window.drupalSettings.user.role
    };
  },
  computed: {
    attributes() {
      return {
        learner: this.learner,
        observation: this.observation,
        date: this.observationDate,
        time: this.observationTime,
      };
    },
  },
  components: {
    ViewerObservation,
    Popper,
    Spinner,
    Datetime,
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    draftSend() {
      this.isStarted = true;
    },
    initData(submissionUuid, draftUuid) {
      if (submissionUuid) {
        this.isCompleted = window.drupalSettings.form_builder[
          this.nuuid
        ].submissions[submissionUuid].hasOwnProperty("isCompleted")
          ? window.drupalSettings.form_builder[this.nuuid].submissions[
              submissionUuid
            ].isCompleted
          : null;
      }

      if (draftUuid) {
        this.isStarted = window.drupalSettings.form_builder[
          this.nuuid
        ].submissions[draftUuid].hasOwnProperty("isStarted")
          ? window.drupalSettings.form_builder[this.nuuid].submissions[
              draftUuid
            ].isStarted
          : null;
      }

      for (let item in this.observations) {
        if (this.observations[item].value == this.observation) {
          this.observationTitle = this.observations[item].label;
        }
      }
      for (let item in this.learners) {
        if (this.learners[item].value == this.learner) {
          this.learnerName = this.learners[item].label;
        }
      }
    },
    deleteObservation() {
      this.showLoader = true;
      let submissionUuid =
        this.draft_suuid != null ? this.draft_suuid : this.suuid;
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch(
          "/jsonapi/observation_submission/observation_submission/" +
            submissionUuid,
          {
            credentials: "include",
            method: "DELETE",
            headers: fetch_headers,
          }
        )
          .then(() => {
            window.location.href = "/observations";
          })
          .catch(() => {
            this.showLoader = false;
          });
      });
    },
    emitAttributes() {
      this.$emit("set-attributes", this.attributes);
    },
    closeDeletePopper() {
      this.$refs["popperTrigger"].$el.click();
    },
  },
  watch: {
    learner(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.emitAttributes();
        if (!this.isCompleted) {
          this.$refs["viewer-observation"].updateAttributes();
        }
      }
    },
    observation(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.emitAttributes();
        if (!this.isCompleted) {
          this.$refs["viewer-observation"].updateAttributes();
        }
      }
    },
    observationDate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.emitAttributes();
        if (!this.isCompleted) {
          this.$refs["viewer-observation"].updateAttributes();
        }
      }
    },
    observationTime(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.emitAttributes();
        if (!this.isCompleted) {
          this.$refs["viewer-observation"].updateAttributes();
        }
      }
    },
  },
};
</script>
<style lang="scss">
.module-observation {
  .fb-step-header {
    display: none;
  }

  h1 {
    font-size: 36px !important;
    line-height: 54px !important;
    margin: 0;
    text-align: left;
  }
  .md-card {
    position: unset !important;
    z-index: unset;
  }
}
.observation-header {
  .md-field.md-field:not(.md-datepicker) {
    margin: 16px 4px !important;
  }
  background-color: $blue-dark !important;
  border-radius: 30px;
  box-shadow: 0px 0px 4px 0px rgba(79, 75, 75, 0.6);
  color: #ffffff;
  .md-field.fb-select {
    label {
      color: #ffffff !important;
      font-size: 16px !important;
      font-family: $font-source-sans-pro !important;
    }
  }
  .text {
    color: #ffffff;
    display: flex;
    align-self: center;
    font-family: $font-source-sans-pro;
    font-size: 16px;
  }
}

.observation-create .text {
  display: flex;
  align-self: center;
  font-family: $font-source-sans-pro;
  font-size: 16px;
}

.observation-create .md-button {
  color: $blue-active !important;
}

.observation-create .md-button.md-primary {
  background-color: $blue-active !important;
  color: #ffffff !important;
}

.observation-create .md-field:not(.md-datepicker) {
  margin: 24px 4px !important;
  padding-top: 0px !important;
  min-height: unset;
  &:first-child {
    margin-top: 0px !important;
  }
  &:last-child {
    margin-bottom: 0px !important;
  }
}

.observation-create .date {
  .md-field {
    margin-bottom: 0px !important;
  }
  .md-datepicker {
    padding: 0px;
    min-height: 0px;
    .md-input-action {
      top: 4px !important;
    }
  }
}
</style>
